import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import axios from 'axios'

//Material UI
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'

// Phone Input
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'

// Loader
import Loader from '../Loader/Loader'

// Translation
import { Language } from '../../Translation'

// Styles
import { makeStyles } from '@material-ui/core/styles'

// Redux
import { connect } from 'react-redux'
import { addClient } from '../../redux/actions/clientActions'

const useStyles = makeStyles((theme) => ({
    media: {
        height: '100%',
        maxHeight: 300,
        paddingTop: 5,
        paddingBottom: 5,
    },
    footer: {
        backgroundColor: "#f5f5f5",
        width: "100%",
        bottom: 0,
        zIndex: 1000,
    },
    labelSpacing: {
        top: 20,
        marginBottom: 20,
    },
    notes: {
        top: 20,
        marginBottom: 100,
    },
    box: {
        textAlign: "center",
        marginBottom: 70,
    },
    continueButton: {
        width: "100%",
        backgroundColor: "#003366",
    },
    errorPhone: {
        color: "#f44336",
        marginLeft: 14,
        marginRight: 14,
        marginTop: 3,
        fontSize: "0.75rem",
        lineHeight: 1.66,
        letterSpacing: "0.03333em",
    },
}));

const DiningDelivery = ({ clientData, storeData, addClient }) => {

    const [client, setClient] = useState({
        UID: 0,
        name: "",
        phone: "",
        email: "",
        address: "",
        apt: "",
        city: "",
        zipCode: "",
        notes: "",
        pickup: "",
        diningOption: "Price_Delivery",
        diningView: "Delivery_View",
    })

    const { language } = clientData
    const { store } = storeData

    const [loading, setLoading] = useState(false)

    const [showInputs, setShowInputs] = useState(false)
    const [phoneInputStatus, setPhoneInputStatus] = useState(false)
    const [editClient, setEditClient] = useState(false)

    const [addressError, setAddressError] = useState("")
    const [emailError, setEmailError] = useState("")
    const [nameErrorText, setNameErrorText] = useState("")
    const [phoneError, setPhoneError] = useState(true)

    const classes = useStyles()
    const history = useHistory()

    const handleValidation = () => {

        let infoIsValid = true

        if (client.phone === "") {
            infoIsValid = false
            setPhoneError(false)
            setNameErrorText(Language.DiningPhoneError[language])
        }
        else if (client.phone.length < 10) {
            infoIsValid = false
            setPhoneError(false)
            setNameErrorText(Language.DiningPhoneErrorLength[language])
        } else {
            setPhoneError(true)
        }

        if (client.address === "" && showInputs === true) {
            infoIsValid = false
            setAddressError(true)
        } else {
            setAddressError(false)
        }

        if (client.email === "" && showInputs === true) {
            infoIsValid = false
            setEmailError(true)
        } else {
            setEmailError(false)
        }

        return infoIsValid

    }


    const handleGetPhone = async () => {

        let data = {
            clientKey: store.CLIENT_KEY,
            clientPhone: client.phone,
        }

        await axios.post(process.env.REACT_APP_API_GET_PHONE, data)
            .then((response) => {

                console.log(response.data)

                // Stop Loading...
                setLoading(false)

                // CLIENT INFO SUCCESS
                if (response.data.Status === "Okay") {
                    handleclient(response.data.clientInfo)
                    setShowInputs(true)
                    setEditClient(true)
                }

                // SOCKET FAIL
                if (response.data.Status === "SOCKET_FAIL") {
                    console.log("SOCKET_FAIL")
                }

                // CLIENT_NOT_FOUND
                if (response.data.Status === "CLIENT_NOT_FOUND") {
                    setShowInputs(true)
                }

            }, (error) => {

                // Stop Loading...
                setLoading(false)

                // Show error to the user
                //setOrderError(error)
                console.log(error)
            });

    }

    const handleCreateClient = async () => {

        client.clientKey = store.CLIENT_KEY

        await axios.post(process.env.REACT_APP_API_NEW_CLIENT, client)
            .then((response) => {

                // Stop Loading...
                setLoading(false)

                // Set UID after creating a new client and store it in the session
                let userInfo = response.data.Result
                let data = userInfo.split("|")

                // CLIENT INFO SUCCESS
                if (response.data.Status === "Okay") {

                    // Update Client Info
                    client.UID = data[1]

                    // Add client info to redux
                    addClient(client)

                    // Go to menu
                    history.push("menu")

                }

                // SOCKET FAIL
                if (response.data.Status === "SOCKET_FAIL") {
                    console.log("SOCKET_FAIL")
                }


            }, (error) => {

                // Stop Loading...
                setLoading(false)

                // Show error to the user
                //setOrderError(error)
                console.log(error)
            });

    }

    const handleUpdateClient = async () => {

        client.clientKey = store.CLIENT_KEY

        await axios.post(process.env.REACT_APP_API_UPDATE_CLIENT, client)
            .then((response) => {

                // Stop Loading...
                setLoading(false)

                // CLIENT INFO SUCCESS
                if (response.data.Status === "Okay") {
                    // Add client info to redux
                    addClient(client)
                    history.push("menu")
                }

                // SOCKET FAIL
                if (response.data.Status === "SOCKET_FAIL") {
                    console.log("SOCKET_FAIL")
                }


            }, (error) => {

                // Stop Loading...
                setLoading(false)

                // Show error to the user
                //setOrderError(error)
                console.log(error)
            });
    }

    const handleButtonClick = async () => {

        if (handleValidation()) {

            setLoading(true)
            setPhoneInputStatus(true)

            if (showInputs === false) {
                handleGetPhone()
            }

            if (client.UID === 0 && showInputs === true) {
                handleCreateClient()
            }

            if (client.UID !== 0 && editClient === true) {
                handleUpdateClient()
            }
        }
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleButtonClick()
        }
    }

    const handleclient = (userInfo) => {

        let data = userInfo.split("|")

        setClient(
            {
                ...client,
                UID: data[1],
                name: data[2],
                address: data[3],
                apt: data[4],
                city: data[5],
                zipCode: data[6],
                notes: data[7],
                email: data[8],
            })
    }

    return (
        <>
            <Box p={1}>
                <div style={{ paddingTop: 20 }}>
                    <PhoneInput
                        country={'ca'}
                        onlyCountries={['ca']}
                        disabled={phoneInputStatus}
                        value={client.phone}
                        onChange={phone => setClient({ ...client, phone: phone })}
                        onEnterKeyPress={handleKeyPress}
                        disableDropdown={true}
                        placeholder={'XXX-XXX-XXXX'}
                        inputStyle={{ width: '100%' }}
                        disableCountryCode={true}
                        isValid={phoneError}

                    />
                </div>
                {!phoneError && <p className={classes.errorPhone}>{nameErrorText}</p>}

                {showInputs &&
                    <>
                        <Typography align={'center'} style={{ paddingTop: 20 }} variant="h5">{Language.DiningDeliveryAddress[language]}</Typography>

                        <TextField
                            id="email"
                            autoComplete={"email"}
                            label={Language.DiningEmail[language]}
                            className={classes.labelSpacing}
                            multiline
                            fullWidth
                            rowsMax={4}
                            value={client.email.includes("<EOF>") ? '' : client.email}
                            onChange={event => {
                                const { value } = event.target;
                                setClient({ ...client, email: value })
                            }}
                            variant="outlined"
                            error={emailError}
                            helperText={emailError === true ? Language.DiningEmailError[language] : ''}
                        />

                        <TextField
                            id="name"
                            autoComplete={"name given-name username family-name"}
                            label={Language.DiningName[language]}
                            className={classes.labelSpacing}
                            multiline
                            fullWidth
                            rowsMax={4}
                            value={client.name}
                            onChange={event => {
                                const { value } = event.target;
                                setClient({ ...client, name: value })
                            }}
                            variant="outlined"
                        />

                        <TextField
                            id="address"
                            autoComplete={"shipping street-address"}
                            label={"Address *"}
                            className={classes.labelSpacing}
                            multiline
                            fullWidth
                            rowsMax={4}
                            value={client.address}
                            onChange={event => {
                                const { value } = event.target;
                                setClient({ ...client, address: value })
                            }}
                            variant="outlined"
                            error={addressError}
                            helperText={addressError === true ? Language.DiningAddressError[language] : ''}
                        />

                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    id="city"
                                    autoComplete={"shipping address-level2"}
                                    label={"City"}
                                    className={classes.labelSpacing}
                                    multiline
                                    fullWidth
                                    rowsMax={4}
                                    value={client.city}
                                    onChange={event => {
                                        const { value } = event.target;
                                        setClient({ ...client, city: value })
                                    }}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    id="zipCode"
                                    autoComplete={"postal-code"}
                                    label={"Zip Code"}
                                    className={classes.labelSpacing}
                                    multiline
                                    fullWidth
                                    rowsMax={4}
                                    value={client.zipCode}
                                    onChange={event => {
                                        const { value } = event.target;
                                        setClient({ ...client, zipCode: value })
                                    }}
                                    variant="outlined"
                                />
                            </Grid>
                        </Grid>
                        <TextField
                            id="notes"
                            label={"Special delivery note"}
                            className={classes.notes}
                            multiline
                            fullWidth
                            rows="6"
                            value={client.notes}
                            onChange={event => {
                                const { value } = event.target;
                                setClient({ ...client, notes: value })
                            }}
                            variant="outlined"
                        />
                    </>
                }
            </Box>
            <Card className={classes.footer}>
                <CardContent>
                    <Button onClick={() => handleButtonClick()} className={classes.continueButton} variant="contained" size="large">
                        <Typography style={{ color: "white" }}>{Language.DiningContinue[language]}</Typography>
                    </Button>
                </CardContent>
            </Card>
            <Loader loading={loading} />
        </>
    )
}

const mapDispatchToProps = dispatch => {
    return {
        addClient: (clientInfo) => dispatch(addClient(clientInfo))
    }
}

const mapStateToProps = state => {
    return {
        storeData: state.storeData,
        clientData: state.clientData
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DiningDelivery)